import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DirInfosType, FileInfosType, ResponseDataBody } from 'src/types/websocket'

type FileInfoProcessType = {
  processFileInfo: {
    // 총 페이지 갯수
    p_filePageLength: number | null
    // 페이지네이션의 숫자 표기 갯수 만큼 나눈 배열
    p_filePageDivisionArray: []
    //가공한 데이터에서 현재 페이지가 포함된 배열
  }
}

export type ExplorerFileListItemsType = ResponseDataBody.ExplorerFileList & FileInfoProcessType

const initialState: ResponseDataBody.ExplorerFileList & FileInfoProcessType = {
  FileInfos: [],
  FileTotal: null,
  DirInfos: [],
  Path: '',
  DirTotal: null,
  processFileInfo: {
    p_filePageLength: null,
    p_filePageDivisionArray: [],
  },
}

const ExplorerFileListSlice = createSlice({
  name: 'explorerFileList',
  initialState,
  reducers: {
    setExplorerFileList(state, action: PayloadAction<ResponseDataBody.ExplorerFileList>) {
      const { FileInfos, FileTotal, DirTotal, DirInfos, Path } = action.payload
      state.FileInfos = sortArrayByName<FileInfosType>(
        FileInfos?.map((element) => {
          return { ...element, check: false }
        }),
      ) as FileInfosType[]
      state.FileTotal = FileTotal
      state.DirTotal = DirTotal
      state.DirInfos = sortArrayByName<DirInfosType>(DirInfos)
      state.Path = Path
      state.processFileInfo = {
        p_filePageLength: setPageNumber(Number(FileTotal ?? 0) + Number(DirTotal ?? 0)).length,
        p_filePageDivisionArray: DivisionArray(
          setPageNumber(Number(FileTotal ?? 0) + Number(DirTotal ?? 0)),
        ),
      }
    },
    setExplorerFileInfos(state, action) {
      state.FileInfos = action.payload
    },
    ResetExplorerFileList(state) {
      state.FileInfos = []
      state.FileTotal = null
      state.DirInfos = []
      state.Path = ''
      state.DirTotal = null
      state.processFileInfo = {
        p_filePageLength: null,
        p_filePageDivisionArray: [],
      }
    },
  },
})

export const { setExplorerFileList, ResetExplorerFileList, setExplorerFileInfos } =
  ExplorerFileListSlice.actions

export default ExplorerFileListSlice.reducer

//총 페이지 배열
const setPageNumber = (f_d_Total: number) => {
  //한 페이지당 컨텐츠 갯수
  const DivisionNumber = 30
  return Array.from({ length: Math.ceil(f_d_Total / DivisionNumber) }, (_, index) => index + 1)
}

const DivisionArray = (inputArray: number[]) => {
  return inputArray.reduce((result: any, item: number, index: number) => {
    // 한번에 노출시키는 페이지 갯수
    const DisplayPageNumber = 5
    const chunkIndex = Math.floor(index / DisplayPageNumber)
    if (!result[chunkIndex]) {
      result[chunkIndex] = []
    }
    result[chunkIndex].push(item)
    return result
  }, [])
}

const sortArrayByName = <T extends { Name: string }>(array: T[] | undefined) => {
  array?.sort((a, b) => {
    const nameA = a.Name.toLowerCase()
    const nameB = b.Name.toLowerCase()

    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }

    return 0
  })

  return array
}
